import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getProducts } from 'app/entities/product/product.reducer';
import { createEntity, getEntity, reset, updateEntity } from './daily-product-usage.reducer';

export const DailyProductUsageUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const products = useAppSelector(state => state.product.entities);
  const dailyProductUsageEntity = useAppSelector(state => state.dailyProductUsage.entity);
  const loading = useAppSelector(state => state.dailyProductUsage.loading);
  const updating = useAppSelector(state => state.dailyProductUsage.updating);
  const updateSuccess = useAppSelector(state => state.dailyProductUsage.updateSuccess);

  const handleClose = () => {
    navigate('/daily-product-usage');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getProducts({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.price !== undefined && typeof values.price !== 'number') {
      values.price = Number(values.price);
    }
    values.from = convertDateTimeToServer(values.from);
    values.util = convertDateTimeToServer(values.util);
    if (values.dailyUsage !== undefined && typeof values.dailyUsage !== 'number') {
      values.dailyUsage = Number(values.dailyUsage);
    }

    const entity = {
      ...dailyProductUsageEntity,
      ...values,
      product: products.find(it => it.id.toString() === values.product?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          from: displayDefaultDateTime(),
          util: displayDefaultDateTime(),
        }
      : {
          ...dailyProductUsageEntity,
          from: convertDateTimeFromServer(dailyProductUsageEntity.from),
          util: convertDateTimeFromServer(dailyProductUsageEntity.util),
          product: dailyProductUsageEntity?.product?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="crawlerBackendApp.dailyProductUsage.home.createOrEditLabel"
            data-cy="DailyProductUsageCreateUpdateHeading"
          >
            <Translate contentKey="crawlerBackendApp.dailyProductUsage.home.createOrEditLabel">
              Create or edit a DailyProductUsage
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="daily-product-usage-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('crawlerBackendApp.dailyProductUsage.price')}
                id="daily-product-usage-price"
                name="price"
                data-cy="price"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('crawlerBackendApp.dailyProductUsage.from')}
                id="daily-product-usage-from"
                name="from"
                data-cy="from"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.dailyProductUsage.util')}
                id="daily-product-usage-util"
                name="util"
                data-cy="util"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.dailyProductUsage.dailyUsage')}
                id="daily-product-usage-dailyUsage"
                name="dailyUsage"
                data-cy="dailyUsage"
                type="text"
              />
              <ValidatedField
                id="daily-product-usage-product"
                name="product"
                data-cy="product"
                label={translate('crawlerBackendApp.dailyProductUsage.product')}
                type="select"
              >
                <option value="" key="0" />
                {products
                  ? products.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/daily-product-usage"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DailyProductUsageUpdate;
